import React, { useState } from 'react'
import Box from '@material-ui/core/Box'

import { Modal, ModalHeader, ModalContent, ModalSubHeader } from '@components/Modal'
import { Button } from '@components/Button'

export const DeleteJointPlanModal = ({ jointScenarioPath, open, onClose }) => {
  const [setDeletingJointPlan, deletingJointPlan] = useState(false)

  const deleteJointPlan = () => {
    setDeletingJointPlan(true)
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]').content

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>
        Delete joint plan
      </ModalHeader>

      <ModalSubHeader>
        Are you sure you want to delete this joint plan?
      </ModalSubHeader>

      <ModalContent>
        <Box display='flex' justifyContent='center' gridGap='1rem'>
          <Button secondary onClick={onClose}>Cancel</Button>

          <form method='post' action={jointScenarioPath}>
            <input type="hidden" name="_method" value="delete" />
            <input value={csrfToken} type='hidden' name='authenticity_token' />
            <Button type='submit' disabled={deletingJointPlan} primary onClick={deleteJointPlan}>
              { deletingJointPlan ? 'Deleting joint plan' : 'Delete joint plan' }
            </Button>
          </form>
        </Box>
      </ModalContent>
    </Modal>
  )
}
